module.exports = __webpack_public_path__ + "img/no_portrait_mode.d7a4f681.gif";